
<div class="Dialog-body">              
  <label style="font-weight: bold; font-size: 18px;" class="get-label">Add New Built #
  </label>
<div>
  <mat-form-field class="header-form-full-width">
    <mat-label>Enter Built #</mat-label>
    <input   (focusout)="checkBuiltNo($event)" type="text" matInput placeholder="Enter Built #" [(ngModel)]="modelName">
  </mat-form-field>
</div>
  

  <div class="buttonbelow">         
    <button mat-button (click)="AddBuiltNo()">Submit</button>
    <button mat-button  (click)="DialogClose()" >Cancel</button>    
  </div>
</div>
